import React from 'react';
import { Slider } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
import { borderRadius, display, MUIStyledCommonProps } from '@mui/system';

const SliderContainer = styled('div')<{ bgcolor: string }>(({ bgcolor }) => ({
	backgroundColor: bgcolor,
	borderRadius: 20,
	height: '40px',
	position: 'relative',
	border: '1px solid #0000000D',
	transition: 'background-color 0.4s ease',
}));

const CustomSlider = styled(Slider)<{ bgcolor: string }>(({ bgcolor }) => ({
	height: 40,
	padding: '0 0px !important',
	width: 'calc(100% - 70px)',
	margin: '0 0px 0 35px',
	'& .MuiSlider-rail': {
		height: 0,
		opacity: 0,
		display: 'none'
	},
	'& .MuiSlider-track': {
		height: 40,
		border: 'none',
		borderRadius: 20,
		// backgroundColor: bgcolor,
		margin: '0 0 0 -35px',
		display: 'none'
	},
	'& .MuiSlider-thumb': {
		//marginLeft: 0,
		height: 32,
		width: 62,
		borderRadius: 16,
		backgroundColor: '#fff',
		boxShadow: 'none',
		border: '1px solid #0000000D',
		'&:hover, &.Mui-focusVisible': {
			boxShadow: '0px 0px 0px 1px rgba(76, 175, 80, 0.16)',
		},
		'&.Mui-active': {
			boxShadow: '0px 0px 0px 3px rgba(76, 175, 80, 0.16)',
		},
	},
}));

const interpolateColor = (value: number) => {
	const colors = [
		{ start: 0, stop: 20, color: '#FF5151' }, // #FF5151
		{ start: 20, stop: 40, color: '#FF8251' }, // #FF8251
		{ start: 40, stop: 60, color: '#FFC551' }, // #FFC551
		{ start: 60, stop: 80, color: '#75ba4c' }, // #75ba4c
		{ start: 80, stop: 100, color: '#4CAF50' }, // #4CAF50
	];

	const color = colors.find((c) => value >= c.start && value < c.stop);
	return color?.color || '#4CAF50';
};

type Props = {
	value: number;
	onChange: (value: number) => void;
	// ...
} & MUIStyledCommonProps<Theme>;

const IMSlider = ({ value, onChange, ...rest }: Props) => {
	const backgroundColor = React.useMemo(() => interpolateColor(value), [value]);

	return (
		<SliderContainer bgcolor={backgroundColor} {...rest}>
			<CustomSlider
				bgcolor={backgroundColor}
				value={value}
				onChange={(e, newValue) =>
					onChange(Array.isArray(newValue) ? newValue[0] : newValue)
				}
				min={0}
				max={99}
			/>
		</SliderContainer>
	);
};

export default IMSlider;
